const _baseUrl = "http://next.sigmastock.net";
export const getUrl=(url)=>{
  if(!url) return null
  if(url.indexOf("http") !== 0){
      return `${_baseUrl}${url}`
  }
  return url;
}
export const getCompanyLogo=(s)=>{
  if(!s)
      return null
  if(s.indexOf('http')==0)
      return s;
  return `${_baseUrl}/logos/${s}`
}

export const clientNoauthPost = (url,param)=>{
  console.log(url,param)
  return fetch(getUrl(url), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(param),
    })
  .then(r=>r.json())
  .catch(e=>{
      console.log(url,e)
      throw e
  })
}
export const toHHddmmyyyy=(s)=>{
  if(!s || s.indexOf('-') <0 || s.indexOf('T') <0)
    return s;
  var a = s.split('T')
  var d = a[0].split('-')
  var h = a[1].split(':')
  return `${h[0]}:${h[1]} | ${d[2]}/${d[1]}/${d[0]}`
}
export const toddmmyyyyHH=(s)=>{
  if(!s || s.indexOf('-') <0 || s.indexOf('T') <0)
    return s;
  var a = s.split('T')
  var d = a[0].split('-')
  var h = a[1].split(':')
  return `${d[2]}/${d[1]}/${d[0]} ${h[0]}:${h[1]}`
}
export const todate=(s)=>{
  var a = s.split('T')
  var d = a[0].split('-').map(c=>parseInt(c))
  var h = a[1].split(':').map(c=>parseInt(c))
  return new Date(d[0],d[1]-1,d[2],h[0],h[1],h[2])
}
export const toTime=(s)=>{
  if(!s)
    return 0;
  var a = s.split('T')
  var d = a[0].split('-').map(c=>parseInt(c))
  var h = a[1].split(':').map(c=>parseInt(c))
  return new Date(d[0],d[1]-1,d[2],h[0],h[1],h[2]).getTime()
}
export const toddmmyyyy2=(s)=>{
  return `${nu2m(s.getDate())}/${nu2m(s.getMonth() +1)}/${s.getFullYear()}`
}
export const toddmmyyyy3=(s)=>{
  return `${s.getFullYear()}${nu2m(s.getMonth() +1)}${nu2m(s.getDate())}`
}
export const nu2m=(n)=>{
  return n>9?String(n):('0' + n)
}
export const formatHour=(s)=>{
  if(!s)
    return '';
  var date = todate(s);
  var now = new Date();
  now = new Date(now.toDateString())
  if(date <now )
      return toddmmyyyy2(date)
 return `${nu2m(date.getHours())}:${nu2m(date.getMinutes())}`
}

//////////////



export const getService=(name)=>{
    return `http://sigmastock.net/api/Service/${name}`
}

export const fetchData=(url)=>{
    return new Promise((resolve,reject)=>{
        fetch(getService(url)).then(r=>r.json()).then(r=>resolve(r)).catch(e=>reject(e))
    })
}
export const formatDate=(d)=>{
    let dd= d.split('T')
    return `${dd[1]} ${dd[0]}`
}

export const setCookie=(cname, cvalue)=>{
    var d = new Date();
    d.setTime(d.getTime() + (60*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
export const getCookie=(cname)=>{
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }